<div flex="fill" dropdown vbDropdown #mobileMenuDropdown="bs-dropdown">
	<button dropdownToggle id="mainMenu" type="button" class="show-nav btn main-nav-btn btn-mobile dropdown-toggle" [ngClass]="{ 'btn-mobile-open bounceInLeft': mobileMenuDropdown.isOpen }" [attr.aria-label]="'UI_MainMenu' | translate" [attr.aria-pressed]="!!mobileMenuDropdown.isOpen" (click)="onToggleClick()">
		<span class="glyphicons theme-accent-txt animated" [ngClass]="mobileMenuDropdown.isOpen ? 'remove_2' : 'show_lines'"></span>
	</button>
	<div *dropdownMenu class="dropdown-menu mobile-menu util-break-word" [ngClass]="{'theme-header-bg' : isNettrixTheme}">
		<div class="container-fluid height-full" [ngClass]="{'theme-header' : isNettrixTheme}">
			<ul class="mobile-menu-list" role="menu" aria-labelledby="mainMenu">
				@if(!isNettrixTheme && enableSearch) {
					<li class="search-cell" *vbAuthorizationKey="'distribution.authenticated'; fallback true" (click)="$event.stopPropagation()">
						<search-header class="theme-Classic-search-header" [headerType]="'Classic'"></search-header>
					</li>
				}
				<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="'authenticated'" role="presentation">
					<a [uiSref]="landingState.state" [uiParams]="landingState.params" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
						<span class="vb-icon vb-icon-home"></span>
						{{ 'Home' | translate }}
					</a>
				</li>

				<li class="mobile-menu-list-item" [ngClass]="{'isOpen' : showVideoMenu,
								'active': $state.includes(PORTAL_MEDIA_STATE) && !showVideoMenu}" *vbAuthorizationKey="'authenticated'" role="presentation">
					<button type="button" class="label-text-spacing" (click)="onVideoMenuClick(); $event.stopPropagation()" [ngClass]="{'active' : showVideoMenu}" role="menuitem">
						<span class="vb-icon vb-icon-video"></span>
						{{ 'Media_Videos' | translate }}
						<div flex="1"></div>
						<i class="float-right glyphicons animated menu-item-icon" [ngClass]="{'chevron-right' : !showVideoMenu,
										'chevron-down flipInX' : showVideoMenu}">
						</i>
					</button>

					<my-videos-menu-items *ngIf="showVideoMenu"></my-videos-menu-items>
				</li>

				<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="'authenticated'" role="presentation">
					<a [uiSref]="PORTAL_TEAM_STATE" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
						<span class="vb-icon vb-icon-channels"></span>
						{{ 'Teams_Title' | translate }}
					</a>
				</li>

				@if (isGuestMode) {
					@if(enableSearch) {
						<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true" role="presentation">
							<a *vbAuthorizationKey="['guest']" [uiSref]="PORTAL_MEDIA_ALL_STATE" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
								{{ 'Media_AllVideos' | translate }}
							</a>
						</li>
					}

					@if (enableCategories) {
						<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true" role="presentation">
							<a *vbAuthorizationKey="['guest']" [uiSref]="PORTAL_MEDIA_BROWSE_STATE" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
								{{ 'Media_Categories' | translate }}
							</a>
						</li>
					}
				}

				@if (!isGuestMode || enablePublicWebcastAccess) {
					<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="['authenticated', 'distribution.authenticated', isGuestMode ? 'guest' : '']" role="presentation">
						<a [uiSref]="CALENDAR_STATE_NAME" [uiOptions]="{ inherit: false }" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
							<span class="vb-icon vb-icon-events" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']"></span>
							{{ 'Events' | translate }}
						</a>
					</li>
				}

				<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizeState="'portal.admin'" role="presentation">
					<a uiSref="portal.load-admin" [uiParams]="{ accountId: account.id }" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
						<span class="vb-icon vb-icon-settings"></span>
						{{ (isAnalystAdmin ? 'Analytics' : 'Admin') | translate }}
					</a>
				</li>

				@if(!account.readonlyUserProfile) {
					<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']" role="presentation">
						<a uiSref="portal.userProfile" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
							<span class="vb-icon vb-icon-person"></span>
							{{ 'UserProfile_MyProfile' | translate }}
						</a>
					</li>
				}

				<ng-container *ngIf="showManageSubscriptions">
					<li *vbAuthorizationKey="['authenticated']" role="presentation" class="mobile-menu-list-item">
						<a [uiSref]="'portal.manageSubscriptions'" role="menuitem" class="line-height-1">
							<span class="vb-icon vb-icon-subscriptions"></span>
							{{ 'ManageSubscriptions' | translate }}
						</a>
					</li>
				</ng-container>

				<li class="mobile-menu-list-item" [ngClass]="{'isOpen' : showHelpMenu}" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']" role="presentation">
					<div class="help-menu-container">
						<help-menu-mobile [ngModel]="subMenu" [currentTheme]="theme" (onMobileHelpMenuToggled)="showHelpMenu = $event">
						</help-menu-mobile>
					</div>
				</li>

				<li class="mobile-menu-list-item" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']" role="presentation">
					<a uiSref="logout" role="menuitem">
						<span class="vb-icon vb-icon-exit"></span>
						{{ 'Logout' | translate }}
					</a>
				</li>

				@if(enableSignIn) {
					<li class="mobile-menu-list-item" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true" role="presentation">
						<button type="button" (click)="loginRedirect()" tabindex="0" role="menuitem">
							{{ 'SignIn' | translate }}
						</button>
					</li>
				}
			</ul>
		</div>
	</div>
</div>
